import React from 'preact/compat';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";
import Link from '@mui/material/Link';

import CheckboxCheckedIcon from '../icons/CheckboxCheckedIcon';
import CheckboxUncheckedIcon from '../icons/CheckboxUncheckedIcon';
import BookIcon from '../icons/BookIcon';
import DescriptionTooltip from '../LauncherForm/DescriptionTooltip';

const onClickStopPropagation = (event) => {
    event.stopPropagation();
};

const LauncherFeatureButtonPlain = (
    {value, title, selected, onClick, description, isPreview, isCommunity, isService, documentationLink}
) => {
    return <Button variant={selected ? "contained" : "outlined"}
        onClick={() => onClick(value)}
        value={value}
    >
        {selected ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
        <Stack direction="column">
            <Stack direction="row" alignItems="center">
                <Typography className="title"> {title} </ Typography>
                {isCommunity &&
                    <Typography className="tag community"> Micronaut Community </Typography>
                }
                {isPreview &&
                    <Typography className="tag preview"> Micronaut Preview </Typography>
                }
            </Stack>
            <Stack direction="row" alignItems="center" spacing="10px">
                <Typography className="description">
                    {description}
                </ Typography>
                {documentationLink &&
                    <DescriptionTooltip description="Learn more about the service">
                        <Link aria-hidden="true" href={documentationLink} target="_blank" onClick={onClickStopPropagation} tabindex="-1">
                            <BookIcon />
                        </Link>
                    </DescriptionTooltip>
                }
            </Stack>
        </Stack>
    </Button>
};

const LauncherFeatureButton = React.memo(LauncherFeatureButtonPlain, (prevProps, nextProps) => {
    return prevProps.selected === nextProps.selected;
});

export default LauncherFeatureButton;
